import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Button } from '@optimus-web/core';
import DismissibleFormWrapper from '../../DismissibleFormWrapper';
import { isBulkOperationEnabled, getBulkOperationsResourceIds } from '../../../selectors/resources';
import { deselectAllResources, deleteResourcesByIds } from '../../../actions/resources';
import ResourceBulkParentForm from './ResourceBulkEditForm';

const ResourceBulkOperationForm = ({ resourceIds, scope, opened, onClose, onDeleteAll }: $TSFixMe) => {
    const handleDeleteAll = () => onDeleteAll(resourceIds);
    return (
        <DismissibleFormWrapper opened={opened} onClose={onClose} headerButtonTextKey={TextKey.EditSpacePlural}>
            {/* @ts-expect-error $TSFixMeError: Type '{ scope: any; form: string; resourceIds: any; }' is not assignable to type 'IntrinsicAttributes & Omit<Partial<Con... */}
            <ResourceBulkParentForm scope={scope} form={`${scope}-bulk-parent`} resourceIds={resourceIds} />
            <Button onClick={handleDeleteAll} variant="destructive" type="submit">
                <LocalizedText textKey={TextKey.Delete} />
            </Button>
        </DismissibleFormWrapper>
    );
};

export default connect(
    createStructuredSelector({
        opened: isBulkOperationEnabled,
        resourceIds: getBulkOperationsResourceIds,
    }),
    // @ts-expect-error $TSFixMeError: Property 'scope' does not exist on type '{}'.
    (dispatch, { scope }) => ({
        // @ts-expect-error $TSFixMeError: Expected 0 arguments, but got 1.
        onClose: () => dispatch(deselectAllResources(scope)),
        onDeleteAll: (resourcesIds: $TSFixMe) => {
            // @ts-expect-error $TSFixMeError: Expected 0 arguments, but got 1.
            dispatch(deselectAllResources(scope));
            // @ts-expect-error $TSFixMeError: Argument of type '(dispatch: $TSFixMe, getState: $TSFixMe) => void' is not assignable to parameter of type 'Action<any>'...
            dispatch(deleteResourcesByIds(resourcesIds, scope));
        },
    })
)(ResourceBulkOperationForm);
